export const AUTH_TOKEN = "auth_token";
export const INFO = "info";
export const MODE = "mode";
export const USERID = "user_id";
export const USERNAME = "user_name";
export const BRANCH = "branch";
export const GETMENULIST = "getMenuList";
export const GETPROTECTEDROUTE = "getprotectedRouteList";
export const ROLE = "role";
export const SYSTEM_SETTINGS = "system_settings";
